<script setup lang="ts">
import { computed } from 'vue'

import {
  BasketballIncidentId,
  BasketballStatId,
  Participant,
} from '@collector/sportsapi-client-legacy'
import SportIncidentIcon from '@desktop/views/Relation/components/RelationView/SportIncidentIcon.vue'

const props = defineProps<{ participant: Participant; reversed?: boolean }>()

const currentQuarterFouls = computed(() =>
  props.participant.stats?.find(
    ({ id }) => id === BasketballStatId.CurrentQuarterFouls,
  ),
)
</script>

<template>
  <div
    class="flex h-full items-center gap-x-1"
    :class="reversed ? 'justify-start' : 'justify-end'"
    dir="ltr"
  >
    <span class="min-w-4">{{ currentQuarterFouls?.value ?? '-' }}</span>
    <SportIncidentIcon :incidentId="BasketballIncidentId.Foul" />
  </div>
</template>
